import { store } from '@/store';
import api from '@api/Api';

export default {

    login(params) {
        return api().post('/auth/login', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    signup(params) {
        return api().post('/auth/signup', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    signupComplete(params) {
        return api().post('/auth/signup/complete', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    signupUnlock(params) {
        return api().post('/auth/signup/unlock', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    google(params) {
        return api().post('/auth/google', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            store.commit('setUser', response.data.data);
            return response;
        });
    },

    refresh() {
        return api().post('/auth/refresh');
    },

    resetPassword(params) {
        return api().post('/auth/password-reset', params);
    },

    changePassword(params) {
        return api().post('/auth/password-change', params);
    },

    verifyEmail(params) {
        return api().post('/auth/verify-email', params);
    },

    logout(params) {
        return api().post('/auth/logout', params);
    },

}
